export default __webpack_public_path__ + "static/media/sso_twitter.031049c3.svg";